<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ejlM41/tc-custom/9781942266105.jpg?1695282625884" alt="This image is the cover for the book Repeat Offender"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Repeat Offender
      </h1>
      <p class="bookDescription body article font2">
        <b>A <i>Suspense Magazine</i> Best True Crime Book. “Mayhem, madness, and suspense . . . with shocking twists and turns that will keep you riveted!” —Aphrodite Jones, New York Times–bestselling author and host of <i>True Crime with Aphrodite Jones</i></b><br/>  <br/> Las Vegas Police Det. Bradley Nickell brings you the inside scoop on the investigation of the most prolific repeat offender Las Vegas has ever known.<br/>  <br/> Daimon Monroe looked like an average guy raising a family with his diffident schoolteacher girlfriend. But just below the surface, you’ll learn he was an accomplished thief with an uncontrollable lust for excess. His criminal mind had no bounds—he was capable of anything given the proper circumstances.<br/>  <br/> You will be revolted by Monroe’s wealth amassed through thievery, his plot to kill Det. Nickell, a judge, and a prosecutor, and the physical and sexual abuse to which Monroe subjected his daughters.<br/>  <br/> “An action-packed, fast-paced true crime thriller from a real-life ‘Sin City’ cop depicting his battle with a notorious, and dangerous, Las Vegas criminal.” —Steve Jackson, <i>New York Times</i>–bestselling author of <i>Bogeyman</i> and <i>A Clockwork Murder</i><br/>  <br/> “A gripping, true story of a prolific recidivist serial criminal, and the relentless police detective who took him down, despite threats against himself and his family. Heart-pounding at times. An absolute must have book for all crime readers.” —RJ Parker, bestselling author of <i>Revenge Killings</i><br/>  <br/><i>The author is donating 10 percent of the proceeds for the sale of the book to the Rape Crisis Center of Las Vegas</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bradley Nickell, Warren Jamison
      </h2>
      
      <p class="authorDescription body article">Detective Bradley Nickell is a twenty-three-year veteran of the Las Vegas Police Department. A first-person true crime account, REPEAT OFFENDER is his first book. A native of Colorado, he has been married for twenty-six years and lives in Las Vegas, Nevada.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b7b2837c